/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { Wrapper } from '../FieldSet';
import { RadioWrapper } from '../Radio/RadioWrapper';
import { Radio as RadioInput } from '../Radio/Radio';
import { Choice } from '../../TaskInputs/types';
import { isEqual } from '@utils/lodash';

type RadioGroupValue = any;

export interface RadioProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
}

export namespace RadioGroup {
  export interface Props extends React.HTMLAttributes<HTMLInputElement> {
    name: string;
    legend: string;
    choices: Choice[];
    value: RadioGroupValue;
    onChange(value: RadioGroupValue | null): void;
    radioComponent?(props: RadioProps): JSX.Element;
  }
}

export const RadioGroup: React.SFC<RadioGroup.Props> = ({
  value,
  name,
  legend,
  choices,
  onChange,
  radioComponent: Radio = RadioInput,
  ...htmlProps
}) => {
  return (
    <Wrapper legend={legend} data-it="RadioGroup">
      {choices.map(choice => {
        const radioOnChange = () => onChange(choice.value);
        return (
          <RadioWrapper key={`${name}-${choice.value}`}>
            <Radio
              {...htmlProps}
              name={name}
              value={`${choice.value}`}
              id={`${name}-${choice.value}`}
              label={choice.text}
              checked={isEqual(value, choice.value)}
              onChange={radioOnChange}
            />
          </RadioWrapper>
        );
      })}
    </Wrapper>
  );
};
